// packages/eden-table/src/components/Sorting/Context.jsx
import { createContext } from "react";
var SortingContext = createContext({
  columnDecorator: (column) => column
});
var Context_default = SortingContext;
export {
  Context_default as default
};
